import { css } from 'styled-components';

// size settings
export const sizeSmall = css`
    border-radius: 20px;
    border-width: 2px;
    font-size: 14px;
    padding: 0 16px;
`;

export const sizeRegular = css`
    border-radius: 12px;
    font-size: 14px;
    padding: 4px 16px;
`;

export const sizeLarge = css`
    border-radius: 16px;
    border-width: 2px;
    font-size: 16px;
    padding: 4px 20px;
`;
